// Auth Api
export const LOGIN = "users/v1/auth/login"
export const LOGIN_OTP = "users/v1/auth/match-login-otp"
export const RESEND_OTP = "users/v1/auth/resend-otp"
export const VERIFY_EMAIL = "users/v1/auth/verify-email"
export const MATCH_EMAIL_OTP = "users/v1/auth/match-email-otp"
export const SIGNUP = "users/v1/auth/register"
export const FORGOT_PASSWORD = "users/v1/auth/forgot-password"
export const FORGOT_PASSWORD_SAVE = "users/v1/auth/forgot-password-save"
export const LOGIN_WITH_EMAIL = "users/v1/auth/login-with-email"
export const LOGIN_WITH_EMAIL_OTP_MATCH = "users/v1/auth/match-otp-email"
export const REGISTER_PARENT = "users/v1/auth/register-parent"

export const PROFILE_DETAILS = "users/v1/profile/details"
export const PROFILE_UPDATE = "users/v1/profile/update"
export const PROFILE_PIC_UPDATE = "users/v1/profile/profile-photo-upload"
export const PROFILE_COVER_PIC_UPDATE = "users/v1/profile/cover-photo-upload"
export const CHANGE_PASSWORD = "users/v1/profile/reset-password"
export const UPDATE_PHOTOGRAPH_USE = "users/v1/profile/update-photograph-use"
export const SEND_PARENT_INVITATION = "users/v1/profile/send-parent-invitation"
export const PARENT_INVITATION_LIST = "users/v1/profile/parent-invitation-list"
export const ACCEPTED_PARENT_LIST = "users/v1/profile/accepted-parent-list"
export const TOGGLE_PARENT_ACCESS = "users/v1/profile/toggle-parent-access"
export const CHILD_REGISTRATION_STORE = "users/v1/user-forms/registration-package/store"
export const CHILD_REGISTRATION_VIEW = "users/v1/user-forms/registration-package/show"

export const PEOPLE_YOU_MAY_KNOW = "users/v1/profile/people-you-may-know"
export const FOLLOWER_LIST = "users/v1/profile/follower-list"
export const FOLLOWING_LIST = "users/v1/profile/following-list"
export const FOLLOW_UNFOLLOW = "users/v1/profile/follow-request"
export const BLOCKED_USER_LIST = "users/v1/feed/blocked-user-list"
export const BLOCK_UNBLOCK_FOLLOWER = "users/v1/feed/block-unblock-follower"
export const USER_FOLLOW_REQUEST = "users/v1/profile/follow-request"
export const USER_FOLLOW_REQUEST_LIST = "users/v1/profile/follower-request-list"
export const USER_FOLLOW_REQUEST_ACCEPT = "users/v1/profile/accept-follow-request"
export const USER_FOLLOW_REQUEST_DELETE = "users/v1/profile/delete-follow-request"

export const INFLUENCERS_LIST = "users/v1/feed/influencers"
export const LATEST_CHALLENGES = "users/v1/feed/latest-challenges"
export const INFLUENCER_POSTED_CHALLENGES = "users/v1/feed/influencer-posted-challenges"
export const CHALLENGE_PERTICIPATE = "users/v1/feed/participate"
export const CHALLENGE_PERTICIPANTS = "users/v1/feed/participates"
export const CHALLENGE_ADD_PERTICIPANTS_COMMENT = "users/v1/feed/add-participate-comment"
export const CHALLENGE_PERTICIPANTS_COMMENT = "users/v1/feed/participate-comments"
export const CHALLENGE_PERTICIPANTS_COMMENT_LIKE = "users/v1/feed/participate-comment-like"
export const CHALLENGE_PERTICIPANTS_COMMENT_LIKES = "users/v1/feed/participate-comment-likes"
export const CHALLENGE_PERTICIPANTS_COMMENT_DELETE = "users/v1/feed/delete-participate-comment"
export const CHALLENGE_DELETE_PARTICIPATE = "users/v1/feed/participate-delete"
export const CHALLENGE_PERTICIPATE_MEDIA_POST = "users/v1/feed/participate-media-post"
export const CHALLENGE_DETAILS = "users/v1/feed/challenge-details"
export const MARK_AS_WINNER = "users/v1/feed/mark-winner"

export const PROFILE_SEARCH = "users/v1/profile/profile-search"

// Holiday API
export const HOLIDAYS_LIST = "users/v1/user-forms/holidays"

// Medication Administration APIs
export const MEDICATION_ADMINISTRATION_LIST = "users/v1/user-forms/form-administration-medications-list"
export const MEDICATION_ADMINISTRATION_FORM = "users/v1/user-forms/form-administration-non-medications"
export const MEDICATION_ADMINISTRATION_LOGS = "users/v1/user-forms/form-administration-medications-logs"
export const MEDICATION_ADMINISTRATION_DELETE = "users/v1/user-forms/delete-administration-medication"

// Daily Reports API
export const DAILY_REPORTS_LIST = "users/v1/user-forms/daily-reports"
export const DAILY_REPORT_STORE = "users/v1/attendance/daily-report/store"
export const DAILY_REPORT_VIEW = "users/v1/attendance/daily-report/view"

// Menu Chart API
export const MENU_CHART_LIST = "users/v1/user-forms/menulist"

// Accident Reports API
export const ACCIDENT_REPORTS_LIST = "users/v1/user-forms/accident-reports"
export const ACCIDENT_REPORT_STORE = "users/v1/user-forms/store-accident-report"
export const ACCIDENT_REPORT_DELETE = "users/v1/user-forms/delete-accident-report"
export const ACCIDENT_REPORT_SIGNATURE = "users/v1/user-forms/accident-report-signature"
export const ACCIDENT_REPORT_SUBMIT = "users/v1/user-forms/form-accident-report"

// Illness Reports API
export const ILLNESS_REPORTS_LIST = "users/v1/user-forms/illness-reports"
export const ILLNESS_REPORT_STORE = "users/v1/user-forms/store-illness-report"
export const ILLNESS_REPORT_DELETE = "users/v1/user-forms/delete-illness-report"
export const ILLNESS_REPORT_SIGNATURE = "users/v1/user-forms/illness-report-signature"
export const ILLNESS_REPORT_SUBMIT = "users/v1/user-forms/form-illness-report"

// Allergy Action Plan API
export const ALLERGY_ACTION_PLANS_LIST = "users/v1/user-forms/individual-allergy-action-plans"
export const ALLERGY_ACTION_PLAN_SUBMIT = "users/v1/user-forms/form-individual-allergy-action-plans"

// Lunch Plan Waiver API
export const LUNCH_PLAN_WAIVERS_LIST = "users/v1/user-forms/lunch-plan-waivers"
export const LUNCH_PLAN_WAIVER_SUBMIT = "users/v1/user-forms/form-lunch-plan-waiver"

// No Peanut Policy API
export const NO_PEANUT_POLICY_LIST = "users/v1/user-forms/no-peanut-policy"
export const NO_PEANUT_POLICY_SUBMIT = "users/v1/user-forms/form-no-peanut-policy"

// Emergency Contacts API
export const EMERGENCY_CONTACTS_LIST = "users/v1/user-forms/emergency-contacts"
export const EMERGENCY_CONTACT_SUBMIT = "users/v1/user-forms/form-emergency-contact"
export const EMERGENCY_CONTACT_DELETE = "users/v1/user-forms/delete-emergency-contact"

// Child Registration API
export const CHILD_REGISTRATION_LIST = "users/v1/user-forms/child-registrations"
export const CHILD_REGISTRATION_SUBMIT = "users/v1/user-forms/form-child-registration"
export const CHILD_REGISTRATION_DELETE = "users/v1/user-forms/delete-child-registration"

export const FEED_POST = "users/v1/feed/feedpost"
export const FEED_MEDIA_POST = "users/v1/feed/feed-media-post"
export const FEEDS_LIST = "users/v1/feed/feeds"
export const FEEDS_DETAIL = "users/v1/feed/feed"
export const FEED_LIKE = "users/v1/feed/feedlike"
export const FEED_LIKES = "users/v1/feed/feed-likes"
export const FEED_DELETE = "users/v1/feed/feed-delete"
export const FEED_TAGGED_USERS = "users/v1/feed/tagged-users"
export const COMMENT_POST = "users/v1/feed/add-post-comment"
export const COMMENT_LIST = "users/v1/feed/comments"
export const DELETE_COMMENT = "users/v1/feed/delete-post-comment"
export const COMMENT_LIKE = "users/v1/feed/post-comment-like"
export const COMMENT_LIKES = "users/v1/feed/post-comment-likes"
export const PROFILE_GALLERY = "users/v1/feed/user_post_media"
export const REPORT_FLAGS_LIST = "users/v1/flag/report-flags"
export const POST_FLAG = "users/v1/flag/post-flag"

export const STORIES_LIST = "users/v1/stories/list"
export const STORIES_VIEW = "users/v1/stories/story-view"
export const STORIS_ADD_COMMENT = "users/v1/feed/add-story-image-comment"

export const NOTIFICATION_LIST = "users/v1/notification/list"
export const NOTIFICATION_READ = "users/v1/notification/read-notification"
export const NOTIFICATION_DELETE = "users/v1/notification/delete-notification"
export const NOTIFICATION_COUNT = "users/v1/notification/notification-count"

export const AD_POST = "users/v1/feed/save-adpost"
export const AD_LIST = "users/v1/feed/get-adpost"
export const AD_EDIT = "users/v1/feed/edit-adpost"
export const AD_DETAILS = "users/v1/feed/get-my-adpost-report"
export const AD_PRICE_CALCULATE = "users/v1/feed/calculate-ad-price"
export const GET_MY_ADS = "users/v1/feed/get-my-adpost"
export const AD_CLICK_TRACK = "users/v1/feed/click-track"
export const AD_CLICK = "users/v1/feed/click-track"
export const AD_VIEW = "users/v1/feed/click-view"
export const AD_POST_REPORT = "users/v1/feed/get-my-adpost-report"
export const AD_DELETE = "users/v1/feed/delete-adpost"

export const CHAT_SAVE = "users/v1/chat/save-chat"
export const CHAT_USERS = "users/v1/chat/get-chat-users"
export const CHAT_SINGLE_USER = "users/v1/chat/get-chats"
export const CHAT_READ = "users/v1/chat/read-chat"
export const CHAT_READ_ALL = "users/v1/chat/read-all-chat"
export const CHAT_DELETE = "users/v1/chat/delete-chat"
export const CHAT_EDIT = "users/v1/chat/edit-chat"
export const CHAT_REACT = "users/v1/chat/react-chat"
export const CHAT_REPLY = "users/v1/chat/reply-chat"
export const CHAT_DETAILS = "users/v1/chat/get-chat-details"
export const CHAT_MEDIA_SAVE = "users/v1/chat/save-chat-media"
export const GET_CONNECTED_USERS = "users/v1/profile/get-connected-users"
export const GROUP_CREATE = "users/v1/chat/create-group"
export const GROUP_EDIT = "users/v1/chat/edit-group"
export const GROUP_PROFILE_IMAGE = "users/v1/chat/save-group-media"
export const GROUP_ADD_MEMBER = "users/v1/chat/add-group-member"
export const GROUP_REMOVE_MEMBER = "users/v1/chat/remove-group-member"
export const GROUP_MEMBERS = "users/v1/chat/group-members"
export const GROUP_LIST = "users/v1/chat/group-list"
export const GROUP_CHAT_SAVE = "users/v1/chat/save-group-chat"
export const GROUP_GET_CHAT = "users/v1/chat/get-chats"
export const GROUP_DELETE_CHAT = "users/v1/chat/delete-chat"
export const GROUP_READ_ALL_CHAT = "users/v1/chat/read-all-chat"
export const GROUP_DETAILS = "users/v1/chat/group-details"
export const GROUP_DELETE = "users/v1/chat/delete-group"

export const AI_CHAT_START = "users/v1/chat-ai/start"
export const AI_CHAT_SAVE = "users/v1/chat-ai/save-chat"
export const AI_CHAT_GET = "users/v1/chat-ai/get-chats"
export const AI_CHAT_READ = "users/v1/chat-ai/read-chat"
export const AI_CHAT_READ_ALL = "users/v1/chat-ai/read-all-chat"
export const AI_CHAT_UNREAD_COUNT = "users/v1/chat-ai/unread-chat-count"
export const AI_CHAT_DELETE = "users/v1/chat-ai/delete-chat"

export const EVENT_LIST = "users/v1/events/event-list"
export const EVENT_DETAILS = "users/v1/events/event-details"
export const EVENT_TICKET_BUY = "users/v1/events/ticket-buy"
export const EVENT_ADD_MEMBER = "users/v1/events/add-member"
export const EVENT_MEMBERS = "users/v1/events/members"
export const EVENT_MEMBER_PAYMENT = "users/v1/events/member-payment"
export const EVENT_FIND_MEMBERS = "users/v1/events/find-member"
export const MY_PARTICIPATED_EVENT = "users/v1/events/my-participated-events"
export const EVENT_PROMETERS_LIST = "users/v1/events/event-prometers-list"
export const MY_TICKETS = "users/v1/events/my-tickets"
export const MY_TICKET_CANCEL = "users/v1/events/cancel-ticket"
export const PUBLIC_EVENT_LIST = "public/v1/events/event-list"
export const EVENT_INVITATION = "users/v1/events/send-invitation"
export const PUBLIC_EVENT_DETAILS = "public/v1/events/event-details"
export const EVENT_ADD_TO_FAVORITE = "users/v1/events/add-favorite-event"
export const EVENT_FAVORITE_LIST = "users/v1/events/favorite-event-list"

export const BLOG_LIST = "public/v1/blog/getblogpost"
export const BLOG_LIKE = "users/v1/blog/bloglike"
export const BLOG_COMMENT_LIST = "public/v1/blog/getblogcomments"
export const BLOG_COMMENT_SAVE = "users/v1/blog/saveblogcomment"
export const BLOG_DETAILS = "public/v1/blog/getblogpostdetails"
export const BLOG_CATEGORY = "public/v1/blog/getblogcategorylist"
export const BLOG_TAG_LIST = "public/v1/blog/getblogtaglist"
export const BLOG_LIKES = "public/v1/blog/getbloglikes"
export const MY_BLOG_IMAGE_UPLOAD = "users/v1/blog/imageUpload"
export const MY_BLOG_DELETE = "users/v1/blog/deleteBlog"
export const MY_BLOG_POST = "users/v1/blog/saveBlog"
export const MY_BLOG_POST_LIST = "public/v1/blog/getblogpost"

export const CLASS_LIST = "public/v1/classes/class-list"
export const MY_CLASS = "users/v1/classes/my-classes"
export const TEACHERS_MY_CLASS = "users/v1/classes/teacher-classes"
export const TEACHERS_MY_CLASS_STUDENTS = "users/v1/classes/class-students"
export const CLASS_DETAILS = "users/v1/classes/my-class-details"
export const CLASS_BUY = "users/v1/classes/class-buy"
export const MY_GRADE = "users/v1/grades/my-grade"
export const MY_GRADE_PAY = "users/v1/grades/grade-pay"
export const GRADE_TRANSACTION_PAY = "users/v1/grades/grade-transaction-pay"
export const QUICKBOOK_CARD_SAVE = "users/v1/grades/quickbook-card-save"
export const QUICKBOOK_CARD_LIST = "users/v1/grades/quickbook-card-list"
export const QUICKBOOK_CARD_DELETE = "users/v1/grades/quickbook-card-delete"
export const CLASS_TRANSACTIONS = "users/v1/classes/class-transactions"
export const CLASS_TRANSACTION_PAY = "users/v1/classes/pay-class-transaction"
export const GRADE_TRANSACTIONS = "users/v1/grades/grade-transactions"
export const GRADE_LIST = "users/v1/grades/grade-list"


export const ADMIN_PASS = "users/v1/auth/adminpass"

export const CMS_DETAILS = "public/v1/cms/page-details"
export const GENERAL_SETTINGS = "public/v1/settings/general-settings"

// Unauthenticated public_announcements list (no for_whom/audience filtering) -
// kept for whatever this was originally meant for; the real audience-aware
// endpoints the AnnouncementBanner/announcement pages actually use are below.
export const ANNOUNCEMENT_API = "public/v1/announcement/public-announcement"
export const ANNOUNCEMENT_LIST_API = "users/v1/announcement/list"
export const ANNOUNCEMENT_VIEW_API = "users/v1/announcement/view"

export const TEACHERS_HELPER_CREATE_API = "users/v1/chat-gpt/ai-content-create"
export const TEACHERS_RESULTS_LIST_API = "users/v1/chat-gpt/ai-search-result/list"
export const TEACHERS_RESULTS_LIST_UPDATE_API = "users/v1/chat-gpt/ai-search-result/update"
export const TEACHERS_RESULTS_LIST_SHARE_API = "users/v1/chat-gpt/share-lesson-plan"
export const TEACHERS_RESULTS_LIST_PRINT_API = "users/v1/chat-gpt/lessonplan/print"
export const TEACHERS_RESULTS_LIST_STUDENT_API = "users/v1/classes/class-students"
export const TEACHERS_RESULTS_LIST_DELETE_API = "users/v1/chat-gpt/ai-search-result/delete"
export const TEACHERS_HELPER_CREATE_QUESTIONS_API = "users/v1/chat-gpt/ai-question-create"
export const TEACHERS_QUESTIONS_LIST_API = "users/v1/chat-gpt/questions/list"
export const TEACHERS_QUESTIONS_PUBLISH_API = "users/v1/chat-gpt/ai-test-details/update"
export const TEACHERS_QUESTIONS_OPTION_UPDATE_API = "users/v1/chat-gpt/question/option/add-update"
export const TEACHERS_QUESTIONS_UPDATE_API = "users/v1/chat-gpt/question/update"
export const TEACHERS_QUESTION_OPTION_DELETE_API = "users/v1/chat-gpt/question/option/delete"
export const TEACHERS_QUESTION_DELETE_API = "users/v1/chat-gpt/question/delete"
export const TEACHERS_TEST_DELETE_API = "users/v1/chat-gpt/ai-serach-test/delete"
export const TEACHERS_TEST_PRINT_API = "users/v1/chat-gpt/test/print"
export const STUDENT_TEST_LIST_API = "users/v1/chat-gpt/student-test/list"
export const STUDENT_TEST_SCORE_CALCULATOR_API = "users/v1/chat-gpt/score-calculator"
export const STUDENT_TEST_DETAILS_API = "users/v1/chat-gpt/student-test-details"
export const TEACHERS_TEST_REPORT_LIST_API = "users/v1/chat-gpt/exam-report-list"
export const TEACHERS_TEST_REPORT_UPDATE_API = "users/v1/chat-gpt/question-score/update"
export const TEACHERS_HELPER_ANSWER_SAVE_API = "users/v1/chat-gpt/answer-save-and-chacker"
export const TEACHERS_CREATE_ACTIVITY_API = "users/v1/chat-gpt/ai-activity-create"
export const TEACHERS_ACTIVITY_LIST_API = "users/v1/chat-gpt/ai-activity/list"
export const TEACHERS_ACTIVITY_UPDATE_API = "users/v1/chat-gpt/ai-activity/update"
export const TEACHERS_ACTIVITY_DELETE_API = "users/v1/chat-gpt/ai-activity/delete"
export const TEACHERS_ACTIVITY_PRINT_API = "users/v1/chat-gpt/activity/print"
export const TEACHERS_CONTENT_COUNT_API = "users/v1/chat-gpt/teacher-content-counts"
export const TEACHERS_ROOMS_API = "users/v1/attendance/teacher-rooms"
export const TEACHERS_ROOMS_STUDENTS_API = "users/v1/attendance/room-students"
// All students across every class a teacher teaches - not gated on a
// scheduled class for "today" like TEACHERS_ROOMS_STUDENTS_API, so it works
// as a plain roster (Emergency Contact / Allergy left-menu pages).
export const TEACHERS_CLASS_STUDENTS_API = "users/v1/attendance/class-students"
export const TEACHERS_STUDENT_PARENT_INFO_API = "users/v1/attendance/parent-info"
export const TEACHERS_ROOMS_STUDENTS_ATTENDANCE_API = "users/v1/attendance/store"
export const TEACHERS_MEDICATION_API = "users/v1/attendance/medication/view"
export const TEACHERS_NON_MEDICATION_API = "users/v1/attendance/non-medication/view"
export const TEACHERS_PEANUT_POLICY_API = "users/v1/attendance/peanut-policy/view"
export const TEACHERS_LUNCH_PLAN_WAIVER_API = "users/v1/attendance/lunch-plan-waiver/view"
export const TEACHERS_GET_ASSIGNED_GAMES_API = "users/v1/attendance/games/get-assigned"
export const TEACHERS_ASSIGN_GAMES_NAME_API = "users/v1/attendance/games/names"
export const TEACHERS_ASSIGN_GAME_API = "users/v1/attendance/games/assign"
export const TEACHERS_OBSERVATION_API = "users/v1/attendance/observation/get"
export const TEACHERS_OBSERVATION_SAVE_API = "users/v1/attendance/observation/save"
export const TEACHERS_OBSERVATION_PICKER_DATA_API = "users/v1/attendance/observation/picker-data"
export const TEACHERS_OBSERVATION_GENERATE_API = "users/v1/attendance/observation/generate"
export const TEACHERS_LEARNING_PATH_GENERATE_API = "users/v1/attendance/learning-path/generate"
export const TEACHERS_LEARNING_PATH_GET_API = "users/v1/attendance/learning-path/get"
export const TEACHERS_LEARNING_PATH_UPDATE_API = "users/v1/attendance/learning-path/update"
export const TEACHERS_PARENT_REPORT_SEND_EMAIL_API = "users/v1/attendance/parent-report/send-email"
export const TEACHERS_PARENT_REPORT_POST_TO_FEED_API = "users/v1/attendance/parent-report/post-to-feed"
export const FEED_POST_PILOT = "users/v1/feed/post-pilot"
export const TRANSLATION_LANGUAGES = "users/v1/translation/languages"
export const TRANSLATION_TRANSLATE = "users/v1/translation/translate"
export const TEACHERS_MEDICATION_LOG_STORE_API = "users/v1/attendance/medication/log/store"
export const TEACHERS_MEDICATION_LOG_API = "users/v1/attendance/medication/log/"
export const TEACHERS_NON_MEDICATION_LOG_STORE_API = "users/v1/attendance/non-medication/log/store"
export const TEACHERS_NON_MEDICATION_LOG_API = "users/v1/attendance/non-medication/log/"
export const TEACHERS_ALLERGY_VIEW_API = "users/v1/attendance/allergy-report/view"
export const STUDENT_ATTENDANCE_LIST_API = "users/v1/attendance/student/attendance-list"

// Room assignment / swap (single student, from the attendance screen's per-student Room action)
export const TEACHERS_ROOM_ASSIGN_INFO_API = "users/v1/attendance/room/assign-info"
export const TEACHERS_ROOM_ASSIGN_API = "users/v1/attendance/room/assign"
export const TEACHERS_ROOM_SWAP_API = "users/v1/attendance/room/swap"
export const TEACHERS_ROOM_CANCEL_SWAP_API = "users/v1/attendance/room/cancel-swap"
// Room assignment / swap (bulk, looped per student from the Bulk Actions modal)
export const TEACHERS_ROOM_QUICK_ASSIGN_API = "users/v1/attendance/room/quick-assign"
export const TEACHERS_ROOM_QUICK_SWAP_API = "users/v1/attendance/room/quick-swap"

// Leave Application APIs
export const LEAVE_APPLICATION_API = "users/v1/leave-applications/list"
export const LEAVE_APPLICATION_STORE_API = "users/v1/leave-applications/store"
export const LEAVE_APPLICATION_DELETE_API = "users/v1/leave-applications/delete"

// User Games APIs

export const GAME_CATEGORY_LIST = 'users/v1/user-games/game-category-list';
export const GAME_LIST = 'users/v1/user-games/game-list';
export const GAME_SAVE = 'users/v1/user-games/save-game';
export const GAME_DELETE = 'users/v1/user-games/delete-game';

export const TEACHER_MODULE_PERMISSIONS = 'users/v1/auth/teacher-module-permissions';